import { FEATURE_FLAGS } from "~/feature-flags";
import { type ValueOf } from "~/utils/types";

type FeatureFlags = typeof FEATURE_FLAGS;

export type FeatureFlagLocalKey = keyof FeatureFlags;
export const FEATURE_FLAG_LOCAL_KEYS = Object.keys(
  FEATURE_FLAGS,
) as FeatureFlagLocalKey[];
export type FeatureFlagForeignKey = ValueOf<FeatureFlags>;
export const FEATURE_FLAG_FOREIGN_KEYS = Object.values(FEATURE_FLAGS);

export type FeatureFlagState = Record<FeatureFlagLocalKey, boolean>;

/**
 * Default state for each feature flag.
 * true = enabled by default, false = disabled by default
 */
export const getFeatureFlagDefaults = (): FeatureFlagState => ({
  SALES_PRICES_ENABLED: true,
  PROPERTIES_ENABLED: true,
  COMPANIES_V2_ENABLED: false,
});

/**
 * Feature flag metadata for Feature Flag UI toggle display
 */
export type FeatureFlagMetadata = Record<
  FeatureFlagLocalKey,
  {
    label: string;
  }
>;

export const FEATURE_FLAG_METADATA: FeatureFlagMetadata = {
  SALES_PRICES_ENABLED: {
    label: "Salgspriser",
  },
  PROPERTIES_ENABLED: {
    label: "Ejendomme",
  },
  COMPANIES_V2_ENABLED: {
    label: "Virksomheder 2.0",
  },
} as const;
